import React from 'react'

function RecentUsers({ wiseBanks, wiseBanksLoading, wiseBanksError, paginatedTeams, isUpdating, RenderUserCTA, renderUserStatus, UseRenderMemberName, BankAccountVerification, RotatingLines,
        currentPage, handlePageChange, totalPages, rowsPerPage
}) {
        return (
                <>
                        <div className="card-outer1">
                                <div className="card-outer">
                                        <div className="card-outer-user">
                                                <h3>Recent Users</h3>
                                        </div>

                                        <div className="time-table">
                                                <table style={{ minWidth: "50rem", width: "100%", textAlign: "left" }} className={`${isUpdating ? "loading-fade" : ""}`} >
                                                        <thead>
                                                                <tr>
                                                                        <th style={{ minWidth: "300px" }}>User Name</th>
                                                                        <th>Email</th>
                                                                        <th>Job Title</th>
                                                                        <th>Recipient</th>
                                                                        <th>Bank Account</th>
                                                                        <th>Status</th>
                                                                        <th></th>
                                                                </tr>
                                                        </thead>
                                                        <tbody>
                                                                {!isUpdating && paginatedTeams?.length === 0 ? (
                                                                        <tr>
                                                                                <td colSpan="7" style={{ textAlign: "center" }}>No Data Available</td>
                                                                        </tr>
                                                                ) : (
                                                                        paginatedTeams.map((row, index) => (
                                                                                <tr key={row._id || index}>
                                                                                        <td>
                                                                                                <UseRenderMemberName rowData={row} />
                                                                                        </td>
                                                                                        <td>{row.email}</td>
                                                                                        <td>{row.job_title}</td>
                                                                                        <td>{row.user_wx_comapny?.wx_company || "N/A"}</td>
                                                                                        <td>
                                                                                                <BankAccountVerification
                                                                                                        email={row.email}
                                                                                                        wiseBanks={wiseBanks}
                                                                                                        isLoading={wiseBanksLoading}
                                                                                                        isError={wiseBanksError}
                                                                                                />
                                                                                        </td>
                                                                                        <td>{renderUserStatus(row)}</td>
                                                                                        <td>{RenderUserCTA(row)}</td>
                                                                                </tr>
                                                                        ))
                                                                )}

                                                                {isUpdating && (
                                                                        <>
                                                                                {paginatedTeams.length === 0 && (<tr className="loader-height"><td></td></tr>)}

                                                                                <div className="loasding-spinner-fade">
                                                                                        <div className="loadsing-spinner">
                                                                                                <RotatingLines
                                                                                                        strokeColor="grey"
                                                                                                        strokeWidth="5"
                                                                                                        animationDuration="0.75"
                                                                                                        width="40"
                                                                                                        visible={true}
                                                                                                />

                                                                                        </div>
                                                                                </div>
                                                                        </>
                                                                )}

                                                        </tbody>
                                                </table>

                                        </div>

                                        {/* Pagination */}
                                        {paginatedTeams.length > 0 && (
                                                <ul className="pagination">
                                                        <li className="back">
                                                                <button
                                                                        className={currentPage === 1 ? "disabled" : ""}
                                                                        disabled={currentPage === 1}
                                                                        onClick={() => handlePageChange(currentPage - 1)}
                                                                >
                                                                        Back
                                                                </button>
                                                        </li>
                                                        {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                                                                <li key={page} className={currentPage === page ? "active" : ""}>
                                                                        <button onClick={() => handlePageChange(page)}>{page}</button>
                                                                </li>
                                                        ))}
                                                        <li className="next">
                                                                <button
                                                                        className={currentPage === totalPages ? "disabled" : ""}
                                                                        disabled={currentPage === totalPages || paginatedTeams.length < rowsPerPage}
                                                                        onClick={() => handlePageChange(currentPage + 1)}
                                                                >
                                                                        Next
                                                                </button>
                                                        </li>
                                                </ul>
                                        )}

                                </div>
                        </div>
                </>
        )
}

export default RecentUsers